import { Directive,HostBinding} from '@angular/core';

@Directive({
  selector: '[ztw-carousel-header]'
})
export class ZtwCarouselHeaderDirective {
  @HostBinding('class')calssName='carouselHeader';
  constructor(){}
}



// WEBPACK FOOTER //
// ./node_modules/angular2-carousel-ztw/ztw-carousel-header.directive.ts